import { AfterContentChecked, Component, ElementRef, Input, ViewChild } from "@angular/core";

@Component({
  selector: "brd-demo-popup-module",
  templateUrl: "./demo-popup-module.component.html",
  styleUrl: "./demo-popup-module.component.less",
  standalone: false
})
export class DemoPopupModuleComponent implements AfterContentChecked {
  @Input() description: string;
  @Input() useCases: string[];
  @Input() functionalities: string[];

  @ViewChild("useCaseChips") useCaseChips: ElementRef;
  @ViewChild("functionalityChips") functionalityChips: ElementRef;

  useCaseExpandable = false;
  functExpandable = false;

  ngAfterContentChecked(): void {
    const useCaseChipsDiv = this.useCaseChips?.nativeElement as HTMLDivElement;
    if (useCaseChipsDiv) {
      this.useCaseExpandable = useCaseChipsDiv.clientHeight < useCaseChipsDiv.scrollHeight;
    }

    const functChipsDiv = this.functionalityChips?.nativeElement as HTMLDivElement;
    if (functChipsDiv) {
      this.functExpandable = functChipsDiv.clientHeight < functChipsDiv.scrollHeight;
    }
  }
}
